export default {
	events: {
		'ddc.message': [
			{
				logic: {
					mustInclude: {
						'eventData.taggingType': 'gtm'
					}
				},
				payload: {
					shared: ['[[eventData]]'],
					taggingTarget: '{{REMOVEKEY}}',
					taggingType: '{{REMOVEKEY}}',
					element: '{{REMOVEKEY}}'
				}
			}
		]
	}
};
